import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

interface LoadingOverlayProps {
  startColor?: string;
  middleFirstColor?: string;
  middleSecondColor?: string;
  finishColor?: string;
  borderRadius?: string | number;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  startColor = colorsPalette.loadingAnimation,
  middleFirstColor = colorsPalette.blackPure,
  middleSecondColor = colorsPalette.loadingAnimation,
  finishColor = 'transparent',
  borderRadius = 0,
}) => {
  const classes = useStyles(
    borderRadius,
    startColor,
    middleFirstColor,
    middleSecondColor,
    finishColor,
  )();

  return <div className={classes.loadingOverlay} />;
};

export default LoadingOverlay;
